import React, { Component } from 'react'

// Functions
import { addStyle, removeStyle } from '../../../functions/textEditorFunctions'

// css
import css from '../css/styleSettings.css'


class AbsoluteSetting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      top: undefined,
      right: undefined,
      bottom: undefined,
      left: undefined
    }
  }

  componentDidMount() {
    const { _this } = this.props
    const { style } = _this.state
    const styleName = this.props.styleName || 'position'
    const top = style[`${styleName}-absolute-top`]
    const bottom = style[`${styleName}-absolute-bottom`]
    const right = style[`${styleName}-absolute-right`]
    const left = style[`${styleName}-absolute-left`]

    this.setValue({
      top,
      bottom,
      right,
      left
    })
  }

  setValue = ({ top, bottom, right, left }) => {
    top = top && parseInt(top)
    right = right && parseInt(right)
    bottom = bottom && parseInt(bottom)
    left = left && parseInt(left)

    this.setState({ top, right, bottom, left })
  }

  handleChange = (e, position) => {
    let value = parseInt(e.target.value)

    if (isNaN(value) || value === undefined || value === '') {
      value = undefined
    }

    let absolute = {
      [position]: value
    }

    this.setState(absolute, () => {
      this.addAbsolute()
    })
  }

  addAbsolute = () => {
    const { top, bottom, right, left } = this.state
    const { _this } = this.props
    const styleName = this.props.styleName || 'position'

    const topPx = `${top}px`
    const topVw = `${top}vw`
    const bottomPx = `${bottom}px`
    const bottomVw = `${bottom}vw`
    const rightPx = `${right}px`
    const rightVw = `${right}vw`
    const leftPx = `${left}px`
    const leftVw = `${left}vw`

    addStyle(_this, {
      styleMultiple: [
        { style: `${styleName}`, value: 'absolute' },
        { style: `${styleName}-absolute-top`, value: topPx },
        { style: `${styleName}-absolute-top-vw`, value: topVw},
        { style: `${styleName}-absolute-bottom`, value: bottomPx},
        { style: `${styleName}-absolute-bottom-vw`, value: bottomVw},
        { style: `${styleName}-absolute-right`, value: rightPx},
        { style: `${styleName}-absolute-right-vw`, value: rightVw},
        { style: `${styleName}-absolute-left`, value: leftPx},
        { style: `${styleName}-absolute-left-vw`, value: leftVw}
      ]
    })
  }

  reset = () => {
    const { _this } = this.props
    const styleName = this.props.styleName || 'position'

    this.setState({ top: 0, right: 0, bottom: 0, left: 0 }, () => {
      removeStyle(_this, null, {
        styleMultiple: [
          { style: `${styleName}`},
          { style: `${styleName}-absolute-top`},
          { style: `${styleName}-absolute-top-vw`},
          { style: `${styleName}-absolute-bottom`},
          { style: `${styleName}-absolute-bottom-vw`},
          { style: `${styleName}-absolute-right`},
          { style: `${styleName}-absolute-right-vw`},
          { style: `${styleName}-absolute-left`},
          { style: `${styleName}-absolute-left-vw`}
        ]
      })
    })
  }

  render() {
    const { top, right, bottom, left } = this.state

    return (
      <div className={css.paddingForm}>
        <table>
          <tbody>
            <tr>
              <td className="pd-0 font-0-7">Absolute</td>
              <td className="pd-0 font-0-7 text-right">
                <a className={css.btn} onClick={this.reset}>รีเซ๊ท</a>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className={css.boxInput}>
            <table>
              <tbody>
                <tr>
                  <td width="25%" className="pd-0 font-0-8 center">
                    <input
                      value={top}
                      onChange={(e) => this.handleChange(e, 'top')}
                      className={`${css.input} ${css.inputBorderNone} ${css.inputFirst}`}
                      type="text"
                    />
                  </td>
                  <td width="25%" className="pd-0 font-0-8 center">
                    <input
                      value={left}
                      onChange={(e) => this.handleChange(e, 'left')}
                      className={`${css.input} ${css.inputBorder}`}
                      type="text"
                    />
                  </td>
                  <td width="25%" className="pd-0 font-0-8 center">
                    <input
                      value={bottom}
                      onChange={(e) => this.handleChange(e, 'bottom')}
                      className={`${css.input} ${css.inputBorder}`}
                      type="text"
                    />
                  </td>
                  <td width="25%" className="pd-0 font-0-8 center">
                    <input
                      value={right}
                      onChange={(e) => this.handleChange(e, 'right')}
                      className={`${css.input} ${css.inputBorder} ${css.inputLast}`}
                      type="text"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <table>
            <tbody>
              <tr>
                <td width="25%" className="pd-0 font-0-7 center">บน</td>
                <td width="25%" className="pd-0 font-0-7 center">ซ้าย</td>
                <td width="25%" className="pd-0 font-0-7 center">ล่าง</td>
                <td width="25%" className="pd-0 font-0-7 center">ขวา</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default AbsoluteSetting
